import React from 'react';

function CalendarAddIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      viewBox="0 0 16 16"
      className={className}
    >
      <path
        d="M14.848,2.5H13C13,1.673,12.327,1,11.5,1S10,1.673,10,2.5H6C6,1.673,5.327,1,4.5,1S3,1.673,3,2.5H1.152C0.517,2.5,0,3.068,0,3.767v9.967c0,0.619,0.414,1.112,0.949,1.221C1.011,14.983,1.079,15,1.152,15H9.5c0.276,0,0.5-0.224,0.5-0.5S9.776,14,9.5,14H1.152C1.099,14,1,13.898,1,13.733V3.767C1,3.602,1.099,3.5,1.152,3.5H3v1C3,5.327,3.673,6,4.5,6S6,5.327,6,4.5v-1h4v1C10,5.327,10.673,6,11.5,6S13,5.327,13,4.5v-1h1.848C14.901,3.5,15,3.602,15,3.767V10.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5V3.767C16,3.068,15.483,2.5,14.848,2.5z M5,4.5C5,4.775,4.775,5,4.5,5S4,4.775,4,4.5v-2C4,2.225,4.225,2,4.5,2S5,2.225,5,2.5V4.5z M12,4.5C12,4.775,11.775,5,11.5,5S11,4.775,11,4.5v-2C11,2.225,11.225,2,11.5,2S12,2.225,12,2.5V4.5z"
      />
      <path
        d="M6,7.5C6,7.225,5.775,7,5.5,7h-1C4.225,7,4,7.225,4,7.5v1C4,8.775,4.225,9,4.5,9h1C5.775,9,6,8.775,6,8.5V7.5z"
      />
      <path
        d="M9,7.5C9,7.225,8.775,7,8.5,7h-1C7.225,7,7,7.225,7,7.5v1C7,8.775,7.225,9,7.5,9h1C8.775,9,9,8.775,9,8.5V7.5z"
      />
      <path
        d="M5.5,10h-1C4.225,10,4,10.225,4,10.5v1C4,11.775,4.225,12,4.5,12h1C5.775,12,6,11.775,6,11.5v-1C6,10.225,5.775,10,5.5,10z"
      />
      <path
        d="M8.5,10h-1C7.225,10,7,10.225,7,10.5v1C7,11.775,7.225,12,7.5,12h1C8.775,12,9,11.775,9,11.5v-1C9,10.225,8.775,10,8.5,10z"
      />
      <path
        d="M12,8.5v-1C12,7.225,11.775,7,11.5,7h-1C10.225,7,10,7.225,10,7.5v1C10,8.775,10.225,9,10.5,9h1C11.775,9,12,8.775,12,8.5z"
      />
      <path
        d="M15.5,13H14v-1.5c0-0.276-0.224-0.5-0.5-0.5S13,11.224,13,11.5V13h-1.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5H13v1.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5V14h1.5c0.276,0,0.5-0.224,0.5-0.5S15.776,13,15.5,13z"
      />
    </svg>
  );
}

export default CalendarAddIcon;
